/* =====================================================
   QUICK ADD
===================================================== */

document.addEventListener('submit', async (event) => {

  const form = event.target.closest('[data-quick-add]');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector(
    '[data-quick-add-button]'
  );

  if (!button) return;

  button.classList.add('is-loading');
  button.disabled = true;

  try {

    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    document.dispatchEvent(
      new CustomEvent('digi:cart:refresh')
    );

    document.dispatchEvent(
      new CustomEvent('cart:drawer:open')
    );

  } catch(error) {

    console.error(error);

  } finally {

    button.classList.remove('is-loading');
    button.disabled = false;

  }

});

/* =====================================================
   SEARCH AJAX FILTER
===================================================== */

document.addEventListener('change', async (event) => {

  const target = event.target;

  if (!target.matches('.digi-search-filters__checkbox')) return;

  const form = target.closest(
    '[data-digi-filters-form]'
  );

  if (!form) return;

  const params = new URLSearchParams(
    new FormData(form)
  );

  const url =
    `${form.action}?${params.toString()}`;

  try {

    const response =
      await fetch(url);

    const html =
      await response.text();

    const parser =
      new DOMParser();

    const documentHTML =
      parser.parseFromString(
        html,
        'text/html'
      );

    const newList =
      documentHTML.querySelector(
        '[data-search-list]'
      );

    const currentList =
      document.querySelector(
        '[data-search-list]'
      );

    if (
      newList &&
      currentList
    ) {

      currentList.innerHTML =
        newList.innerHTML;

    }

    const newHeader =
      documentHTML.querySelector(
        '[data-search-header]'
      );

    const currentHeader =
      document.querySelector(
        '[data-search-header]'
      );

    if (
      newHeader &&
      currentHeader
    ) {

      currentHeader.innerHTML =
        newHeader.innerHTML;

    }

    const newCount =
      documentHTML.querySelector(
        '[data-search-count]'
      );

    const currentCount =
      document.querySelector(
        '[data-search-count]'
      );

    if (
      newCount &&
      currentCount
    ) {

      currentCount.innerHTML =
        newCount.innerHTML;

    }

    window.history.replaceState(
      {},
      '',
      url
    );

  } catch(error) {

    console.error(error);

  }

});

/* =====================================================
   MOBILE FILTER DRAWER
===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const filters = document.querySelector(
    '.digi-search-filters'
  );

  const openButton = document.querySelector(
    '[data-digi-filters-open]'
  );

  const closeButtons = document.querySelectorAll(
    '[data-digi-filters-close]'
  );

  if (filters && openButton) {

    openButton.addEventListener('click', () => {

      filters.classList.add('is-open');

      document.body.style.overflow = 'hidden';

    });

  }

  closeButtons.forEach(button => {

    button.addEventListener('click', () => {

      if (!filters) return;

      filters.classList.remove('is-open');

      document.body.style.overflow = '';

    });

  });

});